import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '@/environments/environment';
import {Page} from '@/app/core/models/page';
import {Observable} from 'rxjs';
import {LeaderboardEntry} from '@/app/core/models/bet/leaderboardEntry';
import { Cacheable } from 'ts-cacheable';

@Injectable({
	providedIn: 'root'
})
export class LeaderboardService {

	constructor(
		private readonly http: HttpClient
	) {}

	private readonly SERVICE_URI = `${environment.backendUrl}/leaderboard`;

	@Cacheable({
		maxAge: 5 * 60 * 1000,
		cacheKey: 'getLeaderboard'
	})
	getLeaderboard(year: number, page: number = 0): Observable<Page<LeaderboardEntry>> {
		const params = new HttpParams().set('page', page);

		return this.http.get<Page<LeaderboardEntry>>(
			`${this.SERVICE_URI}/${year}/leaderboard`,
			{ params }
		);
	}

	@Cacheable({
		maxAge: 5 * 60 * 1000,
		cacheKey: 'getPodium'
	})
	getPodium(year: number): Observable<LeaderboardEntry[]> {
		return this.http.get<LeaderboardEntry[]>(
			`${this.SERVICE_URI}/${year}/podium`
		);
	}

	@Cacheable({
		maxAge: 5 * 60 * 1000,
		cacheKey: 'getTop5'
	})
	getTop5LeaderboardBySeason(year: number): Observable<LeaderboardEntry[]> {
		return this.http.get<LeaderboardEntry[]>(
			`${this.SERVICE_URI}/${year}/top5`
		);
	}

}
